import type { TranslationListParams } from './translations.api';

export const translationsKeys = {
  all: ['translations'] as const,
  lists: () => [...translationsKeys.all, 'list'] as const,
  list: (params: TranslationListParams) => [...translationsKeys.lists(), params] as const,
  locales: () => [...translationsKeys.all, 'locales'] as const,
  coverage: () => [...translationsKeys.all, 'coverage'] as const,
};
